export default "__VITE_ASSET__592de73d__"